import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ChatTextInput from "~/chat/vue/widget/form/fields/ChatTextInput.vue";
import {useChatFormInput, useChatFormInputProps} from "~/chat/vue/widget/form/fields/useChatFormInput";


const __default__ = {
    name: "ChatEmailInput"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    ...useChatFormInputProps()
},
  emits: ["update:modelValue", "continue"],
  setup(__props, { expose: __expose, emit: __emit }) {

let props = __props;

let emits = __emit;

let {exposedObject, placeholder} = useChatFormInput(props);

__expose(exposedObject);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ChatTextInput, _mergeProps({
    ref: "input",
    "input-type": "email"
  }, _unref(props), {
    onContinue: _cache[0] || (_cache[0] = ($event: any) => (_unref(emits)('continue'))),
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_unref(emits)('update:modelValue', $event)))
  }), null, 16))
}
}

})